/* fw-ghl-chat-config-override-20260626 */
(function(){
  if(window.__fwGhlChatConfigOverride) return;
  window.__fwGhlChatConfigOverride = true;
  var WIDGET_ID = '6a17a8f29defcaefa6e0efc9';
  var GREETING = 'Hi there! How can I help you today at Furniture World? 😊';
  var BAD = 'Give us a minute to assign you the best person to help you out.';
  function fixConfigPayload(payload){
    try{
      var obj = payload;
      if(typeof obj === 'string') obj = JSON.parse(obj);
      var cfg = obj && (obj.config || obj.data || obj.widget || obj);
      if(cfg && typeof cfg === 'object'){
        cfg['chat-type'] = 'liveChat';
        cfg['all-in-one-chat-types'] = ['liveChat'];
        cfg['live-chat-intro-msg'] = GREETING;
        cfg['prompt-msg'] = GREETING;
        cfg['all-in-one-initial-msg'] = GREETING;
        cfg['show-live-chat-welcome-msg'] = false;
        cfg['sub-heading'] = 'Ask us anything about Furniture World products, orders, finance, delivery, or custom NZ-made furniture.';
        if(cfg['live-chat-user-inactive-msg'] && String(cfg['live-chat-user-inactive-msg']).indexOf('no one is available') !== -1){
          cfg['live-chat-user-inactive-msg'] = 'Please share your details and the Furniture World team will get back to you shortly.';
        }
      }
      return obj;
    }catch(e){ return payload; }
  }
  window.__fwInstallGhlConfigFetchPatch = function(){
    if(!window.fetch || window.__fwGhlConfigFetchPatchInstalled) return;
    window.__fwGhlConfigFetchPatchInstalled = true;
    var nativeFetch = window.fetch;
    window.fetch = function(input, init){
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var isWidgetConfig = url.indexOf('/chat-widget/public/config/' + WIDGET_ID) !== -1;
      /* Chrome processes Attribution-Reporting response headers only on fetch.
         This public config is a plain GET, so use XHR for this one endpoint and
         return the same Response shape the widget expects. */
      if(isWidgetConfig && (!init || !init.method || String(init.method).toUpperCase() === 'GET')){
        /* The config is fetched once during widget bootstrap. Restore native
           fetch immediately so unrelated ad/analytics fetches never pass
           through this shim or inherit its source location in DevTools. */
        window.fetch = nativeFetch;
        return new Promise(function(resolve, reject){
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.withCredentials = !!(init && init.credentials === 'include');
          xhr.onload = function(){
            try{
              var data = fixConfigPayload(xhr.responseText);
              resolve(new Response(JSON.stringify(data), {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: {'content-type':'application/json'}
              }));
            }catch(e){ reject(e); }
          };
          xhr.onerror = function(){ reject(new TypeError('Network request failed')); };
          xhr.onabort = function(){ reject(new DOMException('The operation was aborted.', 'AbortError')); };
          if(init && init.signal){
            if(init.signal.aborted){ xhr.abort(); return; }
            init.signal.addEventListener('abort', function(){ xhr.abort(); }, {once:true});
          }
          xhr.send();
        });
      }
      return nativeFetch.call(this, input, init);
    };
  };
  /* Aria 2026-08-17 (audit): the rendered-text cleaner that lived here was byte-identical to
     the one in fw-ghl-intercept.js, and both scanned the same shadow root twice a second
     forever. Removed — fw-ghl-intercept.js now owns a single mutation-driven cleanup path. */
})();
